const headerEl = document.querySelector('.header')
const headerStubEl = document.querySelector('.js-header-stub')

function getHeaderHeight() {
    return headerEl.clientHeight + 'px'
}

function setHeaderHeightOnHeaderStubElement() {
    headerStubEl.style.height = getHeaderHeight()
}

function setHeaderHeightOnHtmlElement() {
    document.documentElement.style.setProperty(
        '--header-height',
        getHeaderHeight()
    )
}

window.addEventListener('resize', function () {
    if (headerEl && headerStubEl) {
        setHeaderHeightOnHeaderStubElement()
        setHeaderHeightOnHtmlElement()
    }
})

window.addEventListener('DOMContentLoaded', function () {
    if (headerEl && headerStubEl) {
        setHeaderHeightOnHeaderStubElement()
        setHeaderHeightOnHtmlElement()
    }
})
